const API_URL = process.env.REACT_APP_BACKEND_URL;

// Token stored in sessionStorage for cross-origin compatibility.
// The backend supports both Bearer token and httpOnly cookie auth.
const TOKEN_KEY = 'access_token';

const getToken = () => sessionStorage.getItem(TOKEN_KEY);
const setToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const getAuthHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const register = async (email, password, name) => {
  const response = await fetch(`${API_URL}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, name }),
  });

  if (!response.ok) {
    let errorMessage = 'Registration failed';
    try {
      const error = await response.json();
      errorMessage = error.detail || errorMessage;
    } catch (e) { /* parse error */ }
    throw new Error(errorMessage);
  }

  const data = await response.json();
  if (data.access_token) {
    setToken(data.access_token);
  }
  return data;
};

export const login = async (email, password) => {
  const response = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    let errorMessage = 'Login failed';
    try {
      const error = await response.json();
      errorMessage = error.detail || errorMessage;
    } catch (e) { /* parse error */ }
    throw new Error(errorMessage);
  }

  const data = await response.json();
  if (data.access_token) {
    setToken(data.access_token);
  }
  return data;
};

export const logout = async () => {
  clearToken();
  await fetch(`${API_URL}/api/auth/logout`, {
    method: 'POST',
    headers: getAuthHeaders(),
  }).catch(() => {});
};

export const getMe = async () => {
  const response = await fetch(`${API_URL}/api/auth/me`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to get user info');
  }

  return response.json();
};

export const deleteAccount = async () => {
  const response = await fetch(`${API_URL}/api/user/account`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    let errorMessage = 'Failed to delete account';
    try {
      const error = await response.json();
      errorMessage = error.detail || errorMessage;
    } catch (e) { /* parse error */ }
    throw new Error(errorMessage);
  }

  return response.json();
};
